import { useContext } from 'react';
import { AppFlags, FlagsContext } from '../context/FlagContext';

const handler = {
  get(target: AppFlags, name: keyof AppFlags) {
    const value = target[name];
    if (value === undefined) {
      console.warn(
        `You haven't set the flag ${name} in the ${process.env.ENVIRONMENT} env`,
      );
    }
    return value;
  },
};

export function useFlags() {
  const flags = useContext(FlagsContext);
  if (typeof window !== 'undefined' && window.Proxy) {
    return new Proxy(flags, handler);
  }
  return flags;
}
